import Cashback, { QUERY } from 'components/pages/Cashback/Cashback';
import { PROMOTION_TAG } from 'utils/offers';
import { buildPage, buildQueryPreloader } from 'utils/pageHelper';

export default buildPage(Cashback, {
  metaData: {
    title: 'Cashback',
    description:
      'Earn cashback on great products and enjoy your wallet being a little bigger at the end of the month.',
  },
});
export const getStaticProps = buildQueryPreloader(QUERY, {
  requiredTags: [],
  promoTags: [PROMOTION_TAG],
});
